import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Star, Shield, Clock, Gift } from 'lucide-react';
const offers = [{
  icon: <Star className="w-8 h-8 text-[#D4AF37]" data-id="element-184" />,
  title: 'Ưu Đãi Đặc Quyền',
  description: 'Nhận bộ phụ kiện cao cấp miễn phí khi mua xe Maybach trong tháng này'
}, {
  icon: <Shield className="w-8 h-8 text-[#D4AF37]" data-id="element-185" />,
  title: 'Bảo Hành Mở Rộng',
  description: 'Bảo hành 5 năm không giới hạn số km cho tất cả các dòng xe mới'
}, {
  icon: <Clock className="w-8 h-8 text-[#D4AF37]" data-id="element-186" />,
  title: 'Hỗ Trợ Tài Chính',
  description: 'Lãi suất ưu đãi chỉ từ 0.9% trong 36 tháng'
}, {
  icon: <Gift className="w-8 h-8 text-[#D4AF37]" data-id="element-187" />,
  title: 'Quà Tặng Cao Cấp',
  description: 'Tặng gói bảo dưỡng miễn phí trọn đời cho khách hàng VIP'
}];
export function Promotions() {
  return <section className="py-24 bg-[#111] text-white relative overflow-hidden" data-id="element-188">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#D4AF37]/10 to-transparent" data-id="element-189" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-190">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-191">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-192">
            <h4 className="text-[#D4AF37] tracking-widest uppercase text-sm mb-2" data-id="element-193">
              Ưu Đãi Đặc Biệt
            </h4>
            <h2 className="text-4xl md:text-5xl font-light" data-id="element-194">
              ƯU ĐÃI THÁNG NÀY
            </h2>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-195">
            <Button variant="gold" className="mt-6 md:mt-0" data-id="element-196">
              Xem Tất Cả Ưu Đãi
            </Button>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-197">
          {offers.map((offer, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:border-[#D4AF37]/50 transition-colors duration-300 group" data-id="element-198">
              <div className="mb-6 p-4 bg-black/50 inline-block rounded-full group-hover:scale-110 transition-transform duration-300" data-id="element-199">
                {offer.icon}
              </div>
              <h3 className="text-xl font-light mb-4 text-white" data-id="element-200">
                {offer.title}
              </h3>
              <p className="text-gray-400 font-light leading-relaxed mb-6" data-id="element-201">
                {offer.description}
              </p>
              <a href="#" className="text-sm text-[#D4AF37] tracking-widest uppercase border-b border-transparent hover:border-[#D4AF37] transition-all pb-1 inline-block" data-id="element-202">
                Tìm Hiểu Thêm
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}